import {
  BookingApi as BookingApiGenerated,
  CalculateCancellationPenaltyRequest,
  CancelBookingRequest,
  CreateBookingRequest,
  GetBookingStatusRequest,
} from '@/api/generated/fetch-client';
import { WithSignal } from '@/types/typings';

export class BookingApi {
  constructor(private readonly bookingApi: BookingApiGenerated) {}

  async createBooking(requestParameters: WithSignal<CreateBookingRequest>) {
    const { signal, ...args } = requestParameters;
    return await this.bookingApi.createBooking(args, { signal });
  }

  async cancelBooking(requestParameters: CancelBookingRequest) {
    return await this.bookingApi.cancelBooking(requestParameters);
  }

  async calculateCancellationPenalty(
    requestParameters: WithSignal<CalculateCancellationPenaltyRequest>,
  ) {
    const { signal, ...args } = requestParameters;
    return await this.bookingApi.calculateCancellationPenalty(args, { signal });
  }

  async getBookingStatus(requestParameters: WithSignal<GetBookingStatusRequest>) {
    const { signal, ...args } = requestParameters;
    return await this.bookingApi.getBookingStatus(args, { signal });
  }
}
